<h2 mat-dialog-title>
  <span>{{data.title}}</span>
  <button class="dna-dialog-close" mat-dialog-close title="Fechar">&times;</button>
</h2>

<mat-dialog-content class="mat-typography mb-4">
  <h3 style="font-weight: bold">{{data.detail}}</h3>
  <div *ngFor="let message of data.message">
    <span>{{message}}</span><br>
  </div>
  <div style="margin-top: 1rem;" *ngIf="data.useImage">
    <span style="font-weight: bold">Exemplo</span>
    <div style="display: flex; width: 100%; justify-content: center;">
      <img [src]="data.image" style="max-width: 80%" alt="Imagem de confirmação" />
    </div>
  </div>
  <div class="dna-dialog-download-wrap" *ngIf="data.download">
    <a class="dna-dialog-download" [href]="data.download" download>
      <span class="material-icons">download</span>
      Baixar modelo da planilha
    </a>
  </div>

</mat-dialog-content>
<mat-dialog-actions>
  <button class="dna-btn-ghost" mat-dialog-close>Cancelar</button>
  <button class="dna-btn-orange" [mat-dialog-close]="true" cdkFocusInitial>Confirmar</button>
</mat-dialog-actions>
